export const fuelRequestsHistoryMapper = (data, uplinkAgent, t) => {
  if (!Array.isArray(data) || data.length === 0) {
    return { mappedHeaders: [], mappedRows: [] };
  }

  const mappedHeaders = [
    { key: "code", header: "main.fuel.fuelHistoryTable.code" },
    { key: "client", header: "main.fuel.fuelHistoryTable.client" },
    { key: "guid", header: "main.fuel.fuelRequestsTable.guid" },
    { key: "created", header: "main.fuel.fuelHistoryTable.created" },
    { key: "fuel", header: "main.fuel.fuelHistoryTable.fuel" },
    { key: "resolutionAt", header: "main.fuel.fuelHistoryTable.closed" },
    { key: "state", header: "main.fuel.fuelHistoryTable.state" },
  ];

  const now = Date.now();

  const filteredData = uplinkAgent
    ? data.filter((item) => {
        const isCanceled =
          item.state === "CANCELED" && item.action === "CANCELED";
        const createdTime = new Date(item.created).getTime();
        const threeDaysInMs = 3 * 24 * 60 * 60 * 1000;
        const isOlderThan3Days = now - createdTime > threeDaysInMs;

        return isCanceled || isOlderThan3Days;
      })
    : data;

  const sortedData = [...filteredData].sort((a, b) => {
    const dateA = new Date(a.resolutionAt).getTime();
    const dateB = new Date(b.resolutionAt).getTime();
    return dateB - dateA;
  });

  const mappedRows = sortedData.map((item) => {
    const row = {};
    Object.keys(item).forEach((key) => {
      if (key === "action" || key === "actionAt") return;
      if (key === "created" || key === "resolutionAt") {
        const date = new Date(item[key]);

        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        const hh = String(date.getHours()).padStart(2, "0");
        const min = String(date.getMinutes()).padStart(2, "0");

        row[key] = `${yyyy}-${mm}-${dd} ${hh}:${min}`;
      } else if (key === "state") {
        switch (item[key]) {
          case "APPROVED":
            if (item.action === "AUTOAPPROVED") {
              row[key] = t("main.fuel.fuelHistoryTable.autoApproved");
            } else row[key] = t("main.fuel.fuelHistoryTable.approved");
            break;
          case "CANCELED":
            row[key] = t("main.fuel.fuelHistoryTable.canceled");
            break;
          case "CANCELEDBYTIMEOUT":
            row[key] = t("main.fuel.fuelHistoryTable.expired");
            break;
          default:
            row[key] = String(item[key]);
        }
      } else {
        row[key] = String(item[key]);
      }
    });
    return {
      ...row,
    };
  });

  return { mappedHeaders, mappedRows };
};
